import { render, staticRenderFns } from "./manage-member.vue?vue&type=template&id=6d24421a&scoped=true"
import script from "./manage-member.vue?vue&type=script&lang=ts&setup=true"
export * from "./manage-member.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./manage-member.vue?vue&type=style&index=0&id=6d24421a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d24421a",
  null
  
)

export default component.exports